'use client';
import React from 'react';
import RecoverPassword from '@/ui/features/authentication/recoverPassword';
import AuthFormWrapper from '@/ui/features/authentication/components/authFormWrapper';
import { useTranslations } from 'next-intl';
import RecoverPasswordFormHeader from '@/ui/features/authentication/components/recoverPasswordFormHeader';
import PasswordResetNotification from '@/ui/features/authentication/components/passwordResetNotification';
import Image from 'next/image';
import appRoutes from '@/constants/routes';
import { Link } from '@/intl/navigation';

function RecoverPasswordPage() {
  const auth = useTranslations('auth');
  const textNav = useTranslations('navigation');
  const [resetEmailSent, setEmailSent] = React.useState(false);

  return (
    <>
      {!resetEmailSent ? (
        <div className="flex flex-col items-center">
          <RecoverPasswordFormHeader
            headerText={auth('recover_password')}
            subHeaderText={auth('easily_reset_password')}
          />
          <AuthFormWrapper formHeader={auth('request_new_password')}>
            {/* form */}
            <RecoverPassword setToggle={setEmailSent} />
            {/* login instead */}
            <Link
              href={appRoutes.login}
              className={`mt-5 block text-center text-secondary hover:text-secondary-dark `}
            >
              {auth('login')}
            </Link>
          </AuthFormWrapper>
        </div>
      ) : (
        <PasswordResetNotification
          subTitle={auth('forms.labels.checkYourMail')}
          extraHref={appRoutes.home}
          extraText={textNav('home')}
          icon={
            <Image
              className="md:h-35 md:w-35 mx-auto h-20 w-20 sm:w-32"
              src={'/icons/sentEmailIcon.svg'}
              alt="sentEmailIcon"
              height={50}
              width={50}
            />
          }
        />
      )}
    </>
  );
}

export default RecoverPasswordPage;
